<template>
  <div
    class="select"
    :class="classes"
  >
    <select
      v-model="fieldData.value"
      :disabled="fieldData.loading || !fieldDefinition.editable || undefined"
    >
      <option
        v-if="!fieldDefinition.required || !fieldDefinition.default"
        :disabled="fieldDefinition.required || undefined"
        :value="null"
      >
        &mdash;
      </option>
      <option
        v-for="choice in fieldDefinition.choices"
        :key="choice"
        :value="choice"
      >
        {{ choice }}
      </option>
    </select>
  </div>
  <p
    class="help is-danger"
    v-for="(error, i) in [...localErrors, ...fieldData.errors]"
    :key="i"
  >
    {{ error }}
  </p>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { type FieldModel, type FieldProps, ValidationError, defineValidator } from '.'

type Constraint = { type: 'enum'; many: false }
const { fieldDefinition } = defineProps<FieldProps<Constraint>>()
const fieldData = defineModel<FieldModel<Constraint>>({ required: true })

const classes = computed(() => ({
  'is-danger': !fieldData.value.valid,
  'is-loading': fieldData.value.loading,
}))

const { localErrors } = defineValidator(fieldDefinition, fieldData.value, (value: unknown) => {
  if (value === null) return
  if (typeof value !== 'string' || !fieldDefinition.choices.includes(value))
    throw new ValidationError([`${value} is not a valid choice`])
})
</script>
